import { IconsCombined } from './icons-combined';
import { SelectModel } from 'src/app/tinea-components/select/models/select-model';
import { UiIcon } from './ui-icon';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { CoreEnum } from 'src/app/enums/core.enum';
import { IDatePickerConfig } from 'ng2-date-picker';

export class ValueCell {

  // icon
  readonly ICON_SORT_DESC = CoreEnum.ICON_SORT_DESC;
  readonly ICON_SORT_ASC = CoreEnum.ICON_SORT_ASC;


  value: string | moment.Moment;              // null, toto, MON_ENUM
  displayedValue: string | number;
  dataId?: string;
  dataType: 'STRING' | 'DATE' | 'NUMBER';          // date ? string ? number ?
  dateFormat?: string;                             // the date format erase the date format in table configuration
  show?: boolean;                                   // show | hide
  iconList?: IconsCombined;
  tooltip: string;
  tooltipPosition: 'above' | 'below' | 'left' | 'right';
  tagType: 'span' | 'button' | 'file' | 'checkbox' | 'chips' | 'multiSelection' | 'splitButton' | 'badges' | 'icon';
  cssClass: string;
  valueCssClass: string;
  onOneLine: boolean;
  columnMaxWidth: string; // 10px, 10%
  htmlElementForEdition: 'INPUT' | 'SELECT' | 'TEXTAREA';
  htmlContent: string;
  editable: boolean;
  select: SelectModel;
  isChecked: Boolean;
  canTriggerRowUpdate: boolean;
  attrAccept: string; // Only use for HTMLL ATTRIBUTE for file Ex: '.csv, .xlsm, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
  isDisabled: boolean;
  datePickerConfig: IDatePickerConfig;
  link : string;
  icon: string;
  menuItems: { value: string, click: () => void }[];
  data: any;
  constructor() {
      this.value = null;
      this.displayedValue = null;
      this.dataId = null;
      this.dataType = 'STRING';
      this.dateFormat = null;
      this.show = true;
      this.iconList = new IconsCombined();
      this.tooltip = null;
      this.tooltipPosition = 'below';
      this.tagType = 'span';
      this.cssClass = '';
      this.valueCssClass = '';
      this.onOneLine = false;
      this.columnMaxWidth = null;
      this.htmlElementForEdition = 'INPUT';
      this.editable = false;
      this.select = null;
      this.isChecked = false;
      this.canTriggerRowUpdate = false;
      this.attrAccept = '';
      this.htmlContent = '';
      this.isDisabled = false;
      this.datePickerConfig = null;
      this.link = '';
      this.icon = '';
      this.menuItems = [];
  }

  addCss(cssClass: string): void {
    if (!this.cssClass.includes(cssClass)) {
      const newCss = this.cssClass.concat(' ', cssClass);
      this.cssClass = newCss;
    }
  }

  removeCss(cssClass: string): void {
    if (this.cssClass.includes(cssClass)) {
      const newCss = this.cssClass.replace(cssClass, '');
      this.cssClass = newCss;
    }
  }

  setOneLine(bool: boolean, maxWidth: string): void {
    this.onOneLine = bool;
    this.columnMaxWidth = maxWidth;
  }

  // ------------------------------------------------------------------------------
  //                                ICON CREATION
  // ------------------------------------------------------------------------------
  generateIcon(iconType: IconType, value: string, cssClass: string = '', dataAttr: string = null, style?: any): UiIcon {
    const icon = new UiIcon();
    icon.type = iconType;
    icon.cssClass = cssClass;
    icon.value = value;
    icon.dataAttr = dataAttr;
    if(style) {
      icon.style = style
    }
    return icon;
  }
  addIcon(direction: 'BEFORE' | 'AFTER', iconType: IconType, value: string, cssClass: string = '', dataAttr: string = null, style?: any): void {
    const icon = this.generateIcon(iconType, value, cssClass, dataAttr, style);
    if (direction === 'BEFORE') {
      this.iconList.iconBefore.push(icon);
    } else {
      this.iconList.iconAfter.push(icon);
    }
  }

  addSortableIcon(columnId: string, sortedByColumnId: string, sortDirection: 'ASC' | 'DESC'): void {
    const icon = this.getSortIcon(columnId, sortedByColumnId, sortDirection);
    this.iconList.iconAfter.push(icon);
  }

  getSortIcon(columnId: string, sortedByColumnId: string, sortDirection: 'ASC' | 'DESC'): UiIcon {
    const icon = new UiIcon();
    icon.type = IconType.SRC;
    icon.cssClass = this.getCssClassSort(columnId, sortedByColumnId, sortDirection);
    icon.value = this.getIconSort(columnId, sortedByColumnId, sortDirection);
    return icon;
  }

  getCssClassSort(columnId: string, sortedByColumnId: string, sortDirection: 'ASC' | 'DESC'): string {
    if (columnId === sortedByColumnId) {
      return sortDirection === 'DESC' ? this.ICON_SORT_DESC : this.ICON_SORT_ASC;
    } else {
      return '';
    }
  }

  getIconSort(columnId: string, sortedByColumnId: string, sortDirection: 'ASC' | 'DESC'): string {
    if (columnId === sortedByColumnId) {
      return sortDirection === 'ASC' ? CoreEnum.IMG_PATH_SORT_ASC : CoreEnum.IMG_PATH_SORT_DESC;
    } else {
      return CoreEnum.IMG_PATH_SORT_NONE;
    }
  }
}
